import { render } from "./PartnersCaroussel.vue?vue&type=template&id=0f06dff3&scoped=true"
import script from "./PartnersCaroussel.vue?vue&type=script&lang=js"
export * from "./PartnersCaroussel.vue?vue&type=script&lang=js"

import "./PartnersCaroussel.vue?vue&type=style&index=0&id=0f06dff3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f06dff3"]])

export default __exports__